import LangEnum from '../../../lang/LangEnum';
import { brazilCountry } from '../../../lib/countries';
import { formatCpfCnpjForList } from '../../../utils/formatters';

interface GetCustomerDocumentLabelAndValueParams {
  cpfcnpj?: string;
  location?: string;
  isPJ?: boolean;
}

export const getCustomerDocumentLabelAndValue = ({
  cpfcnpj,
  location,
  isPJ,
}: GetCustomerDocumentLabelAndValueParams) => {
  const isBrLocation = location === brazilCountry.code;

  if (!isBrLocation || !cpfcnpj) {
    return {
      customerDocumentLabel: LangEnum.GLOBAL_DOCUMENT_NUMBER,
      customerDocumentValue: cpfcnpj || '',
    };
  }

  return {
    customerDocumentLabel: isPJ ? LangEnum.GLOBAL_CNPJ : LangEnum.GLOBAL_CPF,
    customerDocumentValue: formatCpfCnpjForList(cpfcnpj, Boolean(isPJ)),
  };
};
